import { Authority } from '@/shared/security/authority';

const venitUserManagementComponent = () => import('@/venit/admin/user-management/user-management.vue');
const venitOrganizationsManagementComponent = () => import('@/venit/admin/organizations-management/organizations-management.vue');
const venitResourceManagementComponent = () => import('@/venit/admin/resource-management/resource-management.vue');
const venitProductsManagementComponent = () => import('@/venit/admin/products-management/products-management.vue');
const venitFiltersManagementComponent = () => import('@/venit/admin/filters-management/filters-management.vue');
const venitMenuManagementComponent = () => import('@/venit/admin/menu-management/menu-management.vue');
const venitUploadFile = () => import('@/venit/admin/upload-file/upload-file.vue');
const productionImport = () => import('@/venit/admin/production-import/production-import.vue');
const productionJobDetail = () => import('@/venit/admin/production-jobs/production-job-detail.vue');
const productionUnits = () => import('@/venit/admin/production-units/production-units.vue');
const ordersManagement = () => import('@/venit/admin/orders-management/orders-management.vue');
const cartsManagement = () => import('@/venit/admin/carts-management/carts-management.vue');
const partsManagement = () => import('@/venit/admin/parts-management/parts-management.vue');
const partsUpload = () => import('@/venit/admin/parts-upload/parts-upload.vue');
const resourcePropertiesManagement = () => import('@/venit/admin/resource-properties-management/resource-properties-management.vue');
const resourcePermissionsManagement = () => import('@/venit/admin/resource-permissions-dict/resource-permissions-dict.vue');
const userResourcePermissionGroups = () => import('@/venit/admin/user-resource-permission-groups/user-resource-permission-groups.vue');
const correspondenceManagement = () => import('@/venit/admin/correspondence-management/correspondence-management.vue');
const emailTemplatesManagement = () => import('@/venit/admin/correspondence-management/email-templates-management.vue');
const importPropertyMapping = () => import('@/venit/admin/import-property-mapping/import-property-mapping.vue');
const importAutoMatchConfig = () => import('@/venit/admin/import-auto-match-config/import-auto-match-config.vue');


export default [

  {
    path: '/admin/user-management',
    name: 'VenitUserManagement',
    component: venitUserManagementComponent,
    meta: { authorities: [Authority.ADMIN, Authority.MANAGER] },
  },
  {
    path: '/admin/organizations-management',
    name: 'VenitOrganizationsManagement',
    component: venitOrganizationsManagementComponent,
    meta: { authorities: [Authority.ADMIN, Authority.MANAGER] },
  },
  {
    path: '/admin/resource-management',
    name: 'VenitResourceManagement',
    component: venitResourceManagementComponent,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },
  {
    path: '/admin/products-management',
    name: 'VenitProductsManagement',
    component: venitProductsManagementComponent,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },
  {
    path: '/admin/filters-management',
    name: 'VenitFiltersManagement',
    component: venitFiltersManagementComponent,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },
  {
    path: '/admin/menu-management',
    name: 'VenitMenuManagement',
    component: venitMenuManagementComponent,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },
  {
    path: '/admin/upload-file',
    name: 'VenitUploadFile',
    component: venitUploadFile,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },

  {
    path: '/admin/production-import',
    name: 'ProductionImport',
    component: productionImport,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },
  {
    path: '/admin/production-jobs/:id',
    name: 'ProductionJobDetail',
    component: productionJobDetail,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },
  {
    path: '/admin/production-units',
    name: 'ProductionUnits',
    component: productionUnits,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },
  {
    path: '/admin/orders-management',
    name: 'OrdersManagement',
    component: ordersManagement,
    meta: { authorities: [Authority.ADMIN, Authority.SALES] },
  },
  {
    path: '/admin/carts-management',
    name: 'CartsManagement',
    component: cartsManagement,
    meta: { authorities: [Authority.ADMIN, Authority.SALES] },
  },
  {
    path: '/admin/parts-management',
    name: 'PartsManagement',
    component: partsManagement,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },
  {
    path: '/admin/parts-upload',
    name: 'PartsUpload',
    component: partsUpload,
    meta: { authorities: [Authority.ADMIN, Authority.AUTHOR] },
  },
  {
    path: '/admin/resource-properties-management',
    name: 'ResourcePropertiesManagement',
    component: resourcePropertiesManagement,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/resource-permissions-management',
    name: 'ResourcePermissionsManagement',
    component: resourcePermissionsManagement,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/user-resource-permission-groups',
    name: 'UserResourcePermissionGroups',
    component: userResourcePermissionGroups,
    meta: { authorities: [Authority.ADMIN, Authority.MANAGER] },
  },
  {
    path: '/admin/email-history',
    name: 'EmailHistory',
    component: correspondenceManagement,
    meta: { authorities: [Authority.ADMIN, Authority.SALES] },
  },
  {
    path: '/admin/email-templates-management',
    name: 'EmailTemplatesManagement',
    component: emailTemplatesManagement,
    meta: { authorities: [Authority.ADMIN, Authority.MANAGER] },
  },
  {
    path: '/admin/import-property-mapping',
    name: 'ImportPropertyMapping',
    component: importPropertyMapping,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/import-auto-match-config',
    name: 'ImportAutoMatchConfig',
    component: importAutoMatchConfig,
    meta: { authorities: [Authority.ADMIN] },
  },
];
